export enum EnumSexInt {
    Masculino = 0,
    Femenino = 1,
    NoBinario = 3
}
export enum EnumSexText {
    Masculino = "MASCULINO",
    Femenino = "FEMENINO",
    NoBinario = "NO BINARIO"
}

export enum EnumDocumentTypeText {
    PASSPORT = "PASSPORT",
    OTRO = "INE / Lista nominal",
}

export enum EnumDocumentTypeLabel {
    PASSPORT = "No. de pasaporte",
    OTRO = "CIC o Número Vertical",
}

export enum EnumStatusCaptureFace {
    WaitFor = 0,
    Preview = 1,
    FaceCrop = 2,
    Other = 3
}

export enum EnumStatus69SAT {
    Favorable = 0,
    No_Favorable = 1
}

export enum EnumUserRol {
    SUPER_ADMIN = 3,
    ADMIN = 1,
    USER = 2,
    RRHH = 4,
    EXECUTIVE = 5
}
export enum EnumBranch {
    TODAS = 0,
    OTRO = -1,
}

export enum EnumStatusGeneric {
    Active = 1,
    Inactiva = 0,
}

export enum EnumServicesValidation {
    CURP = 1,
    INE_LISTANOMINAL = 2,
    SAT_69B = 3,
    OFAC = 4,
    PEPS = 5,
    COMPARACIONID_SELFIE = 6,
    GEOLOCALIZACION = 7,
    EMAIL_TELEFONO_IP = 8,
    DEDUPLICACION = 9,
    VERIFICACION_INE_HUELLAS = 10,
    VERIFICACION_INE_ROSTRO = 11
}

export enum EnumCompanyDefault {
    BiometriaAplicada = "001"
}

export enum EnumModulesApp {
    ListCompany = "list-company",
    Dashboard = "list-documents",
    Bitacora = "list-history",
    EnrollClient = "enrollment/enrollment",
    ListUser = "list-user",
    ListProducts = "list-products",
    ListBranch = "list-branches",
    ListRollCall = "list-roll-call"
}


export enum EnumRoutesDefault {
    Login = "/login",
    Dashboard = "list-documents",
    UserCae = "cae-user-list"
}

export enum EnumEnrollType {
    Movil_Android = 1,
    Web = 3,
    Movil_iOS = 2,
    Web_responsive = 4
}


export enum EnumFingersName {
    rightThumb = "Pulgar",
    rightIndex = "Índice",
    rightMiddle = "Medio",
    rightRing = "Anular",
    rightLittle = "Meñique",
    leftThumb = "Pulgar",
    leftIndex = "Índice",
    leftMiddle = "Medio",
    leftRing = "Anular",
    leftLittle = "Meñique"
}

export enum EnumFingersPosition {
    rightThumb = 1,
    rightIndex = 2,
    rightMiddle = 3,
    rightRing = 4,
    rightLittle = 5,
    leftThumb = 6,
    leftIndex = 7,
    leftMiddle = 8,
    leftRing = 9,
    leftLittle = 10
}